<template>
  <div class="mains">
    <div class="campus">
      功能模块
      <span>></span>
      <router-link to="watching">微剧场</router-link>
      <span>></span>
      <span @click="tiaozhuan_wjc">上传视频</span>
      <span>></span>
      <router-link to>制作配音</router-link>
    </div>
    <div class="xiaoqu moerduo">
      <el-card :span="24" style="height: 85vh">
        <div class="xiaoqu_1">制作点读</div>
        <div class="shenzhong">
          <i class="img_1">
            <img style="left: -1.44167vw" src="@/assets/img/education-manage/campus/shenzhong.png" alt />
          </i>
          点读页面的点读区域新建区域按钮为：点按之后会出现点读编辑框“区域1”，由您自由拖拽至您所需要编辑点读的区域，并进行命名。
        </div>
        <div class="sp_bj">
          <el-row>
            <el-col :span="14">
              <div class="grid-content bg-purple">
                <div class="sp_bt">视频预览</div>
                <div class="sp_sp">
                  <video :src="v_src" controls></video>
                </div>
              </div>
            </el-col>
            <el-col :span="9" class="sp_fd" style="width: 39.7%">
              <div class="grid-content bg-purple-light">
                <div class="sp_bt">编辑视频</div>
                <div class="sp_zhizuo">
                  <el-upload class="avatar-uploader daorushiping0" action="#" accept=".mp4" :show-file-list="false"
                    :http-request="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                    <el-button type="primary" class="xinjian_fd" round>
                      更换视频
                    </el-button>
                  </el-upload>
                </div>
                <div class="sp_bt">设置字幕(回车换行)</div>
                <div class="textarea">
                  <el-input type="textarea" :rows="10" placeholder="请您在此处进行该视频字幕的编辑及上传，可分段进行上传也可整段
进行上传" v-model="subtitle">
                  </el-input>
                </div>
                <div class="textarea">
                  <el-button type="primary" @click="submitUpdate">确认修改</el-button>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'watchingDubList',
  data() {
    return {
      banji_id: {},
      banji_ids: {},
      v_src: '',
      sentence: '',
      text_id: '',
      seqnums: '',
      //字幕
      subtitle: '',
    };
  },
  created() {
    if (!this.$store.state.watchingear) {
      this.$router.push({ name: 'watchingear' });
      this.$store.commit('watching', this.$store.state.watchingears);
      return this.$message.error('您当前的配音页面获取失败！');
    }
    this.banji_id = this.$store.state.watchingear;
    this.banji_ids = this.$store.state.watchingears;

    this.getWatchById();
  },
  destroyed() {
    localStorage.removeItem('watchingear');
    localStorage.removeItem('watchingears');
  },
  watch: {},
  methods: {
    submitUpdate() {
      let data = {
        videoId: this.banji_id.id,
        videoUrl: this.v_src,
        subtitle: this.subtitle,
      };
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/watch/editVideoInfo',
        method: 'POST',
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success(result.data.message);
          this.$router.push({ name: 'watchingear' });
        })
        .catch(() => {});
    },
    // 上传修改视频
    handleAvatarSuccess(data) {
      let formData = new FormData();
      formData.append('video', data.file);

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadVideo',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success('上传视频成功！');
          this.v_src = result.data.data;
        })
        .catch((err) => {
          this.$message.error('上传视频错误：' + err);
        });
    },
    beforeAvatarUpload() {},

    // 预览视频
    yulan_video(item) {
      // console.log(item)
      if (item.videoempty) {
        this.v_src = item.video_url;
      } else {
        this.$message.error('请先上传视频！');
      }
    },
    tiaozhuan_wjc() {
      this.$store.commit('watching', this.banji_ids);
      this.$router.push({ name: 'watchingear' });
    },
    // 查询视频详情
    getWatchById() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/watch/getWatchById?watchId=' + this.banji_id.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.v_src = result.data.data.video_url;
          this.subtitle = result.data.data.video_text;
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询视频失败：' + err);
        });
    },
  },
};
</script>

<style lang="less">
.xinjian_fd {
  margin-bottom: 20px;
  width: 230px;
  height: 48px;
  font-size: 21px !important;
}
.textarea {
  margin: 20px 0;
}
.wenbenyu {
  i {
    img {
      top: -156px !important;
    }
  }
  .el-textarea__inner {
    width: 360px !important;
    height: 200px !important;
  }
}

.lianzi {
  left: -62px !important;
}
.sp_bj {
  margin: 0 10px;
  .sp_bt {
    font-size: 20px;
    font-weight: bold;
    line-height: 27px;
    color: #00a6e6;
  }
  .sp_sp {
    width: 920px;
    height: 518px;
    margin-top: 33px;
    video {
      width: 100%;
      height: 100%;
      border-radius: 15px;
    }
    video:focus {
      outline: none;
    }
  }
  .sp_fd {
    margin-left: 15px;
    .sp_zhizuo {
      margin-top: 23px;
      .el-upload {
        height: 48px;
        border-radius: 20px;
      }
    }
    .sp_tishi {
      font-size: 14px;
      color: #ccc;
      margin-left: 25px;
    }
    .sp_fdnr:first-child {
      margin-top: 0;
    }
    .sp_fdnr:last-child {
      margin-bottom: 30px;
    }
    .sp_fdnr {
      width: 600px;
      height: 85px;
      line-height: 85px;
      border: 1px solid #ccc;
      margin-top: 20px;
      border-radius: 5px;
      position: relative;
      .el-upload {
        line-height: 30px;
      }
      div {
        // text-align: center;
        margin-left: 30px;
        span {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
        .el-input {
          display: inline-block;
          width: 80px;
          height: 36px;
          margin-left: 8px;
        }

        .el-button {
          width: 89px;
          height: 36px;
          background: #00a6e6;
          border-radius: 17px;
          padding: 0;
          // margin-left: 30px;
          span {
            color: #fff;
            font-size: 14px;
            font-weight: normal;
          }
        }

        .chuanzimu {
          margin-left: 149px;
        }
      }

      .shanghcu {
        width: 23px;
        height: 23px;
        line-height: 23px;
        border: 1px solid #ccc;
        border-radius: 0px 5px 0 5px;
        margin: -1px -1px 0 0;
        float: right;
        font-size: 16px;
        text-align: center;
      }
      .shanghcu:hover {
        background: #666666;
        color: #fff;
      }

      .daorushiping0 {
        position: absolute;
        top: 1px;
        left: 51px;
      }

      .yulan1 {
        background: #d1d1d1 !important;
        border: #d1d1d1;
      }
    }
  }
}
</style>
